import { WhiteboardController } from "@/wbcontroller/WhiteboardController";

/// Store whiteboards separately to prevent Vue from observing all internal properties.
const WBControllerCache: Record<string, WhiteboardController> = {};

export default WBControllerCache;
